// DropdownComponent.js

import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Dropdown, Image } from "react-bootstrap";
import { CloseIconWhite, CheckSecondaryImg } from "constants/Images";

import "./qms-dropdown.css"
import { lowerCase } from "lodash";
import QmsStorageKeys from "constants/QmsStorageKeys";

const QmsDropdown = (props) => {


    const { menuItemStyle, dropdownStyle, item, title, RHs, BHs, DMs, PFAs, CHs, DATEs, selectedTypes, solutionCoverage } = props
    console.log("selectedTypes ", item)

    const [isOpen, setIsOpen] = useState(false);

    const handleItemClick = (value, items) => {
        let role = title
        let id = items.filter((item) => item.agentName === value)[0].agentCode
        if (role === "Region Heads") {
            props.datachnages(value, role, id)
            if (value === "All") {
                props.datachnages(value, "CH", id)
            }
        } else if (role === "CH") {
            props.datachnages(value, role, id)
            if (value === "All") {
                props.datachnages(value, "Branch Heads", id)
            }
        } else if (role === "Branch Heads" || role === "TM") {
            props.datachnages(value, role, id)
            if (value === "All") {
                props.datachnages(value, "DM", id)
            }
        } else if (role === "DM" || role === "BM") {
            props.datachnages(value, role, id)
            if (value === "All") {
                props.datachnages(value, "PFA", id)
            }
        } else if (role === "PFA" || role === "RM") {
            props.datachnages(value, role, id)
        } else if (role === "DATE") {
            props.datachnages(value, role)
        } else if (role === "select") {
            props.datachnages(value, role)
        }
        else if (role === "solution coverage") {
            props.datachnages(value, role)
        }
        setIsOpen(false);
    };

    const handleToggle = (isOpen) => {
        setIsOpen(isOpen);
    };

    const handleDisableCheck = (name) => {

        const title = name
        // let designation_Code = localStorage.getItem(QmsStorageKeys.DESIGNATION_CODE).toLowerCase(S
        // let designation_Code = "bm"
        let designation_Code = localStorage.getItem(QmsStorageKeys.DESIGNATION_CODE) ? localStorage.getItem(QmsStorageKeys.DESIGNATION_CODE).toLowerCase() : ""
        let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
        if (designation_Code) {
            if (designation_Code.includes('rh')) {

                if (title === "Region Heads" || (title === "CH" && channel_code.includes("CBM"))) {
                    return true
                } else {
                    return false
                }
            } else if (designation_Code.includes('ch')) {

                if (title === "Region Heads" || title === "CH") {
                    return true
                } else {
                    return false
                }
            } else if (designation_Code.includes('bh')) {

                if (title === "Branch Heads" || title === "Region Heads" || title === "CH") {
                    return true
                } else {
                    return false
                }
            } else if (designation_Code.includes('dm')) {
                if (title === "Region Heads" || title === "CH" || title === "Branch Heads" || title === "DM") {
                    return true
                } else {
                    return false
                }
            } else if (designation_Code.includes('tm')) {

                if (title === "TM" || title === "Region Heads" || title === "CH") {
                    return true
                } else {
                    return false
                }
            } else if (designation_Code.includes('bm')) {

                if (title === "Region Heads" || title === "TM" || title === "BM" || title === "CH" || (title === "Branch Heads" && channel_code.includes("DIS"))) {
                    return true
                } else {
                    return false
                }
            }
            else if (designation_Code.includes('pfa')) {
                if (title === "DATE" || title === "select" || title === "solution coverage") {
                    return false
                } else {
                    return true
                }
            }
            else if (designation_Code.includes('rm')) {
                if (title === "DATE" || title === "select" || title === "solution coverage") {
                    return false
                } else {
                    return true
                }
            }
        }
    }

    const selectedItem = (role, RHs, BHs, DMs, PFAs, CHs, dates, selectedTypes, solutionCoverage) => {

        const roleMap = {
            "Region Heads": RHs,
            "Branch Heads": BHs,
            "TM": BHs,
            "DM": DMs,
            "BM": DMs,
            "PFA": PFAs,
            "DATE": dates,
            "select": selectedTypes,
            "solution coverage": solutionCoverage,
            "CH": CHs,
            "RM": PFAs

        };

        return roleMap[role];
    };
    return (

        <>

            <Dropdown
                as={ButtonGroup}
                show={isOpen === true ? true : false}
                onSelect={(value) => handleItemClick(value, item)}
                onToggle={handleToggle}
                className="qms-bottomsheet-dropdown d-inline-block  w-100 "
            >
                <div className="dropdown-overlay" />
                <Dropdown.Toggle
                    variant=""
                    className={`${dropdownStyle}  bottomsheet-qmsdropdown-toggle d-flex  align-items-center justify-content-between p-2 rounded border `}
                    disabled={handleDisableCheck(title)}
                >
                    <span className="text-truncate-qms">  {selectedItem(title, RHs, BHs, DMs, PFAs, CHs, DATEs, selectedTypes, solutionCoverage) || 'Select'}</span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="custom-menu-list">
                    <div className='d-flex d-md-none d-block justify-content-between bg-white p-4 align-items-start dropdown-heading'>
                        <h3 className='text-primary-title-label-color font-size-18 mb-0'>{title}</h3>
                    </div>
                    {item.map((item, index) => (

                        <Dropdown.Item
                            key={index}
                            eventKey={item.agentName}
                            className={` ${menuItemStyle} bottomsheet-dropdown-menu-item font-size-14 font-size-md-16 ${selectedItem(title, RHs, BHs, DMs, PFAs, CHs, selectedTypes, solutionCoverage) === item.agentName ? "active" : ""}`}>
                            <div>
                                <span className='ml-2'>{item.agentName}</span>
                            </div>
                            <Image className='mx-1 bottomsheet-dropdown-menu-item-check-icon' src={CheckSecondaryImg} alt='check-icon' />
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>



        </>

    );
};

export default QmsDropdown;
